import classNames from 'classnames'
import { type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type Message } from 'entities/Message/model/Message'
import { MessageActionTooltip } from 'widgets/MessageCard/ui/MessageActionTooltip/MessageActionTooltip'
import { MessageSenderContent } from 'widgets/MessageCard/ui/MessageSenderContent/MessageSenderContent'
import { useSelectedMessage } from 'widgets/MessageCard/hooks/useSelectedMessage'
import { Mentions } from './../Mentions/Mentions'
import styles from './styles.module.scss'
import { type IMessageCardType } from '../types'

type ConversationMessageCardItemProps = {
  message: Message
  type: IMessageCardType
  children: ReactNode
  className?: string | null
}

export const ConversationMessageCardItem: FC<ConversationMessageCardItemProps> = observer(
  ({ message, type, children, className }) => {
    const {
      isOutbound,
      is_schedule,
      isNote,
      isMeet,
      undoPending,
      isConversationsHistory,
      isExternalConversation,
      isFailed,
    } = message

    const { selected, onUnSelected } = useSelectedMessage(message.id)

    return (
      <>
        <MessageActionTooltip message={message} type={type}>
          <div
            className={classNames(
              styles.message,
              {
                [styles.outbox]: isOutbound,
                [styles.schedule]: is_schedule,
                [styles.note]: isNote,
                [styles.meet]: isMeet,
                [styles.undoPending]: undoPending,
                [styles.gifPreview]: type === 'gif-preview',
                [styles.conversationsHistoryView]: isConversationsHistory,
                [styles.external]: (isExternalConversation && !isNote) || message.isTransferred,
                [styles.failed]: isFailed,
                [styles.selected]: selected,
              },
              className
            )}
            data-name={'message'}
            aria-label={'ConversationMessageCardItem'}
            onMouseEnter={() => {
              onUnSelected()
            }}
          >
            <MessageSenderContent />
            {children}
          </div>
        </MessageActionTooltip>
        <Mentions message={message} />
      </>
    )
  }
)
